if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer') ||
          document.querySelector('ajax-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        if (this.closest('.product-bar__sticky')) return;

        // set-bundle dropdown
        if (
          !this.closest('.product__info-container').querySelector(
            '[name="amount-bundle"]'
          ) &&
          this.closest('.product__info-container').querySelector(
            '#set-bundle-discounts'
          )
        )
          return;
        this.quantityEl = this.closest(
          '.product__info-container'
        ).querySelector('[name="quantity"]');
        this.setBundleEl = this.closest(
          '.product__info-container'
        ).querySelectorAll('[name="amount-bundle"]');
        this.setBundleEl.forEach((item) => {
          item.addEventListener('change', this.onSetChange.bind(this));
        });
        this.setBundlePriceEl = this.closest(
          '.product__info-container'
        ).querySelector('.set-bundle--price');

        const discountObj = this.closest(
          '.product__info-container'
        ).querySelector('#set-bundle-discounts');
        if (!discountObj) return;
        this.setBundleDiscounts = JSON.parse(discountObj.textContent);
        this.setBundleDiscounts.sort((a, b) =>
          a['qty-to-buy'] < b['qty-to-buy'] ? 1 : -1
        );
        const discountRulesEl = this.closest(
          '.product__info-container'
        ).querySelector('.set-bundle--discount-rules');
        if (!discountRulesEl) return;
        discountRulesEl.innerHTML = this.setBundleDiscounts
          .map((discount, index) => {
            return `<span class="badge badge--sale" style="--order: ${index}">${discount.title}</span>`;
          })
          .join('');
      }

      onSetChange(event) {
        const price = event.target.dataset.price;
        const bundleSet = event.target.value;
        const quantity = this.quantityEl.value;
        const totalPrice = bundleSet * price * quantity;
        const setBundleDiscounts = this.setBundleDiscounts;
        const setBundlePriceEl = this.setBundlePriceEl;

        // clear price
        setBundlePriceEl.innerHTML = '';

        // show set bundle price
        const setPrice = document.createElement('span');
        setPrice.classList.add('set-price');
        setPrice.textContent = this.formatPrice(totalPrice);
        setBundlePriceEl.appendChild(setPrice);

        // check if discounted
        if (!setBundleDiscounts) return;
        const theDiscount = setBundleDiscounts.find((discount) => {
          return quantity * bundleSet >= discount['qty-to-buy'];
        });

        if (!theDiscount) return;

        // clear price
        setBundlePriceEl.innerHTML = '';

        // show set bundle discounted price
        const setCompareAtPrice = document.createElement('span');
        setCompareAtPrice.classList.add('set-compare-at-price');
        setCompareAtPrice.textContent = this.formatPrice(totalPrice);
        setPrice.textContent = this.formatPrice(
          totalPrice - totalPrice * (theDiscount.discount / 100)
        );

        // append discounted price and badge
        setBundlePriceEl.appendChild(setCompareAtPrice);
        setBundlePriceEl.appendChild(setPrice);
      }

      formatPrice(price) {
        if (!price) return;
        let formattedPrice = price / 100;

        const getLang = () => {
          if (navigator.languages != undefined) return navigator.languages[0];
          return navigator.language;
        };

        formattedPrice = formattedPrice.toLocaleString(getLang(), {
          style: 'currency',
          currency: Shopify.currency.active
        });

        return formattedPrice;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.querySelector('.loading-overlay__spinner') != null)
          this.querySelector('.loading-overlay__spinner').classList.remove(
            'hidden'
          );

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && this.cart.getSectionsToRender) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (formData.get('amount-bundle') && this.setBundleEl) {
          const originalQty = parseInt(formData.get('quantity'));
          const bundleQty = parseInt(formData.get('amount-bundle'));
          const amountBundleEl = this.closest(
            '.product__info-container'
          ).querySelector('[name="amount-bundle"]:checked');
          if (!amountBundleEl) return;
          const selectedSetText =
            amountBundleEl.nextElementSibling.textContent.trim();
          formData.set('quantity', originalQty * bundleQty);
          formData.append('properties[_qty_bundle_orig]', originalQty);
          formData.append('properties[_qty_bundle_per_one]', bundleQty);
          formData.append('properties[qty_bundle_set]', selectedSetText);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (window.cartType === 'p80') {
                      this.cart.toggleCart();
                    } else {
                      this.cart.renderContents(response);
                    }
                  });
                },
                {once: true}
              );
              quickAddModal.hide(true);
            } else {
              if (window.cartType === 'p80') {
                this.cart.toggleCart();
              } else {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (
              this.cart &&
              this.cart.classList.contains('is-empty') &&
              window.cartType !== 'p80'
            )
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (this.querySelector('.loading-overlay__spinner') != null)
              this.querySelector('.loading-overlay__spinner').classList.add(
                'hidden'
              );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
